import { LABELDAY, LABELMONTH, DAY_MONTH_YEAR } from '@/libs/filterDate'
import {
  last2, last30, last7, last90, today, firstDateOfYear,
} from '@/store/helpers'

export const locale = {
  format: 'dd/mm/yyyy',
  daysOfWeek: LABELDAY,
  monthNames: LABELMONTH,
}

export const datePickerRangeGeneral = (current = today) => ({
  Kemarin: [last2, last2],
  '7 Hari Terakhir': [last7, current],
  '30 Hari Terakhir': [last30, current],
  '90 Hari Terakhir': [last90, current],
  '1 Tahun Terakhir': [firstDateOfYear, current],
  'Custom Tanggal ': [],
})

export const storageRequestStatusOptions = [
  { value: '', text: 'Semua Status' },
  { value: 'diajukan', text: 'Proses Pengajuan' },
  { value: 'disetujui', text: 'Disetujui' },
  { value: 'ditolak', text: 'Ditolak' },
]

export const storageRequestTableFields = [
  {
    key: 'submission_date', label: 'Tanggal Pengajuan', thClass: 'bg-white text-capitalize text-black', tdClass: 'text-black', formatter: value => DAY_MONTH_YEAR(value),
  },
  {
    key: 'partner_name', label: 'Nama Partner', thClass: 'bg-white text-capitalize text-black', tdClass: 'text-black',
  },
  {
    key: 'total_product', label: 'Jumlah Produk', thClass: 'bg-white text-capitalize text-black', tdClass: 'text-black',
  },
  {
    key: 'status', label: 'Status', thClass: 'bg-white text-capitalize text-black', tdClass: 'text-black',
  },
  {
    key: 'id', label: 'Action', thClass: 'bg-white text-capitalize text-black', tdClass: 'text-black',
  },
]

export const storageRequestStatus = {
  diajukan: {
    label: 'Proses Pengajuan',
    color: 'text-[#FBA63C]',
    bgColor: 'bg-[#FCEBBE]',
  },
  disetujui: {
    label: 'Disetujui',
    color: 'text-[#34A770]',
    bgColor: 'bg-[#BEFCDE]',
  },
  ditolak: {
    label: 'Ditolak',
    color: 'text-[#E31A1A]',
    bgColor: 'bg-[#FCBEBE]',
  },
}
